var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BookshelfDisplay',{attrs:{"value":_vm.data}}),_c('ozi-loading',{attrs:{"loading":!_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }